var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4,18.8L16.4,18.8c0.6,0,1.3-0.5,1.3-1.3v-11c0-0.6-0.5-1.3-1.3-1.3l0,0c-0.6,0-1.3,0.5-1.3,1.3v11.1 C15.2,18.3,15.7,18.8,16.4,18.8z M7.8,18.8L7.8,18.8c0.6,0,1.3-0.5,1.3-1.3v-11c0-0.6-0.5-1.3-1.3-1.3l0,0c-0.6,0-1.3,0.5-1.3,1.3 v11.1C6.5,18.3,7,18.8,7.8,18.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.829fce8974fab543b4401265b6f4bd8e.svg";
export { ForwardRef as ReactComponent };